import React, { FC } from "react";
import classNames from "classnames";
import { useTranslation } from "react-i18next";
import { useLocation } from "@gatsbyjs/reach-router";
import { SocialLink } from "./components/social-link/SocialLink";

type Props = {
  articleTitle: string;
  className?: string;
};

export const ShareLinks: FC<Props> = ({ articleTitle, className }) => {
  const { t } = useTranslation("t_blog");
  const location = useLocation();
  const shareLinks = {
    twitter: `https://twitter.com/intent/tweet?url=${location.href}&text=${articleTitle}`,
    linkedIn: `https://www.linkedin.com/sharing/share-offsite/?url=${location.href}`,
    facebook: `https://www.facebook.com/sharer.php?u=${location.href}`,
  };

  return (
    <div className={classNames("flex", className)}>
      <div className="w-full md:mx-auto">
        <p className="text-primary-content mb-4">
          {t("share_this_publication")}
        </p>
        <div className="text-regular flex items-center gap-x-4">
          {Object.keys(shareLinks).map((key, i) => (
            <div key={key + i}>
              <SocialLink url={shareLinks[key]} provider={key} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
